import Axios from 'axios'

if(process.env.NODE_ENV === "development"){
    var NEXT_PUBLIC_BACKEND_URL='http://localhost:8000/api'
}else if(process.env.NODE_ENV === "production"){
    var NEXT_PUBLIC_BACKEND_URL='https://oppdb.piano-piano.org/api'
}

const axios = Axios.create({
    baseURL: NEXT_PUBLIC_BACKEND_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
})

export default axios;
